// extracted by mini-css-extract-plugin
module.exports = {"main":"SocialLinks_main__VwPjg","title":"SocialLinks_title__hloKv","linksDiv":"SocialLinks_linksDiv__cFpLi"};